/**
 * @generated SignedSource<<a07bef369ce672281f4fba17f724f867>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuthButton_authLink$data = {
  readonly iconUrl: string | null | undefined;
  readonly label: string;
  readonly url: string;
  readonly " $fragmentType": "AuthButton_authLink";
};
export type AuthButton_authLink$key = {
  readonly " $data"?: AuthButton_authLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"AuthButton_authLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthButton_authLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconUrl",
      "storageKey": null
    }
  ],
  "type": "IconLink",
  "abstractKey": null
};

(node as any).hash = "d655179de2f7b5515401a9e87d7598f9";

export default node;
